module.exports = __webpack_public_path__ + "img/P4220149.596f5fe8.jpg";